export default import.meta.ROLLDOWN_FILE_URL_Betff1KN8SfCalWbBR1Zkg